import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const SwitchViewIcon = ({ width = 20, height = 18, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg width={width} height={height} viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect
        x='11.4883'
        y='0.598045'
        width='7.61539'
        height='6.92308'
        rx='0.8'
        fill={hovered ? fill : 'none'}
        stroke={color}
        strokeLinejoin='round'
      />
      {hovered && (
        <path
          d='M18.3042 10.4789H12.2888C11.8469 10.4789 11.4888 10.8371 11.4888 11.2789V16.602C11.4888 17.0438 11.8469 17.402 12.2888 17.402H18.3042C18.746 17.402 19.1042 17.0438 19.1042 16.602V12.5037V11.2789C19.1042 10.8371 18.746 10.4789 18.3042 10.4789Z'
          fill='white'
        />
      )}
      <path
        d='M19.1042 14.9789V16.602C19.1042 17.0438 18.746 17.402 18.3042 17.402H12.2888C11.8469 17.402 11.4888 17.0438 11.4888 16.602V11.2789C11.4888 10.8371 11.8469 10.4789 12.2888 10.4789H18.3042C18.746 10.4789 19.1042 10.8371 19.1042 11.2789V12.5037'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      {hovered && (
        <path
          d='M1.69585 0.598045H7.71123C8.15306 0.598045 8.51123 0.956217 8.51123 1.39805V6.72112C8.51123 7.16295 8.15306 7.52112 7.71123 7.52112H1.69585C1.25402 7.52112 0.895845 7.16295 0.895845 6.72112V2.62288V1.39805C0.895845 0.956217 1.25402 0.598045 1.69585 0.598045Z'
          fill='white'
        />
      )}
      <path
        d='M0.895845 5.0981V6.72112C0.895845 7.16295 1.25402 7.52112 1.69585 7.52112H7.71123C8.15306 7.52112 8.51123 7.16295 8.51123 6.72112V1.39805C8.51123 0.956217 8.15306 0.598045 7.71123 0.598045H1.69585C1.25402 0.598045 0.895845 0.956217 0.895845 1.39805V2.62288'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        x='0.895508'
        y='10.4789'
        width='7.61539'
        height='6.92308'
        rx='0.8'
        fill={hovered ? fill : 'none'}
        stroke={color}
        strokeLinejoin='round'
      />
    </svg>
  );
};
